import { Component, ViewEncapsulation } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';
import { WorkerBillableItem } from 'src/app/modules/workers/_types/worker-billable-item';
import { WorkerBillableItemsService } from 'src/app/modules/workers/_services/workers-billable-items.service';
import { WorkerBillableItemLinesService } from 'src/app/modules/workers/_services/workers-billable-item-lines.service';
import { WorkersService } from 'src/app/modules/workers/_services/workers.service';
import { Worker } from 'src/app/modules/workers/_types/worker';
import { WorkerBillableItemLine } from 'src/app/modules/workers/_types/worker-billable-item-line';
import { NumberUtilsService } from 'src/app/core/services/number-utils.service';

@Component({
    selector: 'app-worker-billable-items-generator',
    templateUrl: './worker-billable-items-lines-generator.component.html',
    styleUrls: ['./worker-billable-items-lines-generator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WorkerBillableItemsGeneratorComponent {

  public loading: boolean = false;
  public type!: string;

  public filters: any = {
    workerId: new Filter(FilterOperation.equals, 'workerId', ''),
    workerBillableItemTypeId: new Filter(FilterOperation.equals, 'workerBillableItemTypeId', ''),
    startDate: new Filter(FilterOperation.greaterOrEqual, 'startDate', ''),
    endDate: new Filter(FilterOperation.greaterOrEqual, 'endDate', ''),
    active: new Filter(FilterOperation.equals, 'active', '', true)
  };

  public workerBillableItemsLines: WorkerBillableItemLine[] = [];

  public lastGridEvent: any;
  public totalRecords:number = 0;
  public workers: Worker[] = [];
  public workersWithItems: Worker[] = [];
  public displayInfoDialog: boolean = false;
  public selectedLine: WorkerBillableItemLine | null = null;

  constructor(
    private workerBillableItemLinesService: WorkerBillableItemLinesService,
    private workersService: WorkersService,
    private numberUtils: NumberUtilsService
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this.loadWorkers(null);
    this.filters.startDate.value = moment().add(-1, 'month').set('date', 26).startOf('day').toDate();
    this.filters.endDate.value = moment().set('date', 25).startOf('day').toDate();
  }

  clearFilters() {
    this.filters.workerId.value = '';
    this.filters.workerBillableItemTypeId.value = '';
    this.filters.startDate.value = moment().add(-1, 'month').set('date', 26).startOf('day').toDate();
    this.filters.endDate.value = moment().set('date', 25).startOf('day').toDate();
    this.workerBillableItemsLines = [];
    this.workersWithItems = [];
  }

  async onloadFilterWorkers( event: any){
    let text = "";
    if (event != null) {
      if(event.filter.length >= 3) this.loadWorkers(event);
      if(event.filter.length == 0) this.loadWorkers(null);
    }
  }

  async loadWorkers(event: any){
    let text = "";       
    if (event != null) text = event.filter; 

    let filters: any = { };
    if(text != "") filters.name = new Filter(FilterOperation.contains, 'name', "", text);
    //creamos filtros
    let params: IParamsCollection = {
      sort: ['name'],
      page: { size: 10000 },
      fields: { workers: 'name' }
    }
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.workersService.all(params));
    this.workers = response.data;
  }

  async loadWorkerBillableItemLines(forceRefresh: boolean = false, workerBillableItemId?: string){
    //calculamos conceptos facturables
    let response = await firstValueFrom(this.workerBillableItemLinesService.generate(this.filters.startDate.value, this.filters.endDate.value, this.filters.workerId.value, this.filters.workerBillableItemTypeId.value,workerBillableItemId, forceRefresh));
    this.workerBillableItemsLines = response;

    //extraemos los ids unicos de trabajadores que tienen conceptos facturables
    let workerIds = [...new Set(this.workerBillableItemsLines.map((item: WorkerBillableItemLine) => item.workerId))];

    //filtramos los trabajadores para quedarnos solo con los que tienen conceptos facturables
    this.workersWithItems = this.workers.filter((worker: Worker) => workerIds.includes(worker.id??''));

  }

  getWorkerBillableItemLines(workerId: string | undefined): WorkerBillableItemLine[] {
    if(workerId === null || workerId === undefined) return [];
    return this.workerBillableItemsLines.filter((item: WorkerBillableItemLine) => item.workerId === workerId);
  }

  async saveBillableItems(workerId: string | undefined){
    if(!workerId) return;

    //obtenemos los conceptos facturables del trabajador
    var itemsToSave = this.workerBillableItemsLines.filter((item: WorkerBillableItemLine) => item.workerId === workerId);
    for(let item of itemsToSave){
      //quitamos el id
      delete item.id;
    }

    //los guardamos
    await firstValueFrom(this.workerBillableItemLinesService.saveItems(itemsToSave));
    
    //si no ha habido error, los quitamos de la lista de conceptos facturables generados
    this.workerBillableItemsLines = this.workerBillableItemsLines.filter((item: WorkerBillableItemLine) => item.workerId !== workerId);

    //y recargamos los trabajadores con conceptos facturables
    let workerIds = [...new Set(this.workerBillableItemsLines.map((item: WorkerBillableItemLine) => item.workerId))];
    this.workersWithItems = this.workers.filter((worker: Worker) => workerIds.includes(worker.id??''));
  }

  async showInfo(item:WorkerBillableItemLine){
    this.selectedLine = item;
    this.displayInfoDialog = true;
  }

  async onLineChange(line: WorkerBillableItemLine){
    //recalculamos el total y el iva
    line.taxAmount = this.numberUtils.Round(line.price * line.quantity * (line.taxPercent != null ? line.taxPercent / 100 : 0));
    line.subtotal = this.numberUtils.Round(line.price * line.quantity);
    line.total = this.numberUtils.Round(line.subtotal + line.taxAmount);
  }

  async refreshDistance(item: any){
    console.log("Refreshing distance for item", item);
    this.loadWorkerBillableItemLines(true,item.workerBillableItemId);
  }

}
